import Vue from "vue"
import Router from "vue-router"
// eslint-disable-next-line import/no-cycle
import store from '../store';
// import ClientMonitor from 'skywalking-client-js';
// import config from '../../package.json';

Vue.use(Router)

const routes = [
    {
        path: '/cpFlow',
        component:() => import(/* webpackChunkName: "cpFlow" */'@/views/cpFlow.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/studentComplier',
        name:'StudentComplier',
        component:() => import(/* webpackChunkName: "StudentComplier" */'@/views/studentComplier/studentComplier.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/jslist',
        name:'matchList',
        component:()=>import(/* webpackChunkName: "jslist" */'@/views/list/index.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/result',
        name: 'result',
        component: () => import(/* webpackChunkName: "result" */'@/views/result/index.vue'),
        meta: {
            requiresAuth: false,
        },
    }
]
const router = new Router({ routes });
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const userInfo = store.state.user.userInfo || {};
        const token = userInfo.token || userInfo.accessToken || '';
        if (token) {
            next();
        } else {
            next({
                path: '/',
            });
        }
    } else {
        next();
    }
});

router.afterEach(() => {
    // ClientMonitor.setPerformance({
    //     service: process.env.VUE_APP_SERVICE_NAME,
    //     serviceVersion: config.version,
    //     pagePath: to.name,
    // });
});

export { router };